import React from 'react';
import { Close } from 'icons/svg';
import { BspotModal } from 'components/atoms/modal/modal';

export type SlotsModalProps = {
  onClose?(): void;
  show: boolean;
};
export const SlotsModal = ({ onClose, show }: SlotsModalProps) => {
  const onCloseModal = () => {
    onClose();
  };

  return (
    <BspotModal show={show} smallLg={true}>
      <div className={'d-flex flex-row justify-content-between'}>
        <h2 className={'my-0'}>{'Hang On'} </h2>
        <Close size={'16px'} color={'#ffffff'} onClick={onCloseModal} />
      </div>

      <div
        className={'d-flex col-12 text-center justify-content-center py-3 pb-4'}
      >
        <img
          style={{ borderRadius: '4px' }}
          className={'img-fluid'}
          width={'320px'}
          src={'/js_assets/images/slots.gif'}
        />
      </div>
    </BspotModal>
  );
};
export default SlotsModal;
